import React, { Component } from 'react';
import ParkinglocationModel from './ParkinglocationModel';

import { Form, Input, Transfer, Button, Modal } from 'antd';
const FormItem = Form.Item;

class CityForm extends Component {

    state = {
        modalVisible: false,
        transferKeys: [],
        transferTargetKeys: []
    }

    form = null;

    componentWillMount() {
        ParkinglocationModel.getAll()
            .then(data => {
                this.setState({
                    transferKeys: data
                })
            });
    }

    renderTransferItem(item) {
        const customLabel = (
            <span className="custom-item">
                {item.Code} - {item.Name}
            </span>
        );
        return {
            label: customLabel, // for displayed item
            value: item.id, // for title and filter matching
        };
    }

    handleTransferChange(targetKeys, direction, moveKeys) {
        this.props.form.setFieldsValue({
            locations: targetKeys
        });
        this.setState({ transferTargetKeys: targetKeys });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.modalVisible !== this.state.modalVisible) {
            this.setState({
                modalVisible: nextProps.modalVisible
            });
        }
        if (nextProps.initialValues !== this.state.initialValues) {
            if (nextProps.initialValues !== null) {
                this.setState({ transferTargetKeys: nextProps.initialValues.locations });
            }
            this.setState({
                initialValues: nextProps.initialValues
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSuccess(this.props.form, values);
                this.props.onModalCancel(this.props.form);
            }
        });
    }

    renderForm() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        const fullFormItemLayout = {
            labelCol: {
                xs: { span: 0 },
                sm: { span: 0 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Kód" >
                    {getFieldDecorator('code', {
                        rules: [{
                            type: 'string', message: 'Položka musí obsahovat text!',
                        }],
                        initialValue: this.props.initialValues && this.props.initialValues.code
                            ? this.props.initialValues.code
                            : null,
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Název" >
                    {getFieldDecorator('name', {
                        rules: [{
                            type: 'string', message: 'Položka musí obsahovat text!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                        initialValue: this.props.initialValues && this.props.initialValues.name
                            ? this.props.initialValues.name
                            : null,
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...fullFormItemLayout}
                    label="Lokality" >
                    {getFieldDecorator('locations', {
                        initialValue: this.props.initialValues && this.props.initialValues.locations
                            ? this.props.initialValues.locations
                            : null,
                        rules: [{
                            type: 'array', message: 'Položka musí obsahovat pole lokalit!',
                        }, {
                            required: true, message: 'Vyberte prosím alespoň jednu lokalitu!',
                        }],
                    })(
                        <Transfer
                            dataSource={this.state.transferKeys}
                            listStyle={{
                                width: 460,
                                height: 300,
                            }}
                            targetKeys={this.state.transferTargetKeys}
                            onChange={this.handleTransferChange.bind(this)}
                            render={this.renderTransferItem} />
                    )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    {this.props.initialValues
                        ?
                        <Button type="primary" htmlType="submit">Uložit</Button>
                        : <Button type="primary" htmlType="submit">Vložit</Button>
                    }
                </FormItem>

            </Form >
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={1024}
                    title={this.state.initialValues === null ? "Vytvoření nového města" : "Editace města"}
                    visible={this.state.modalVisible}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false, transferTargetKeys: [] });
                    }}
                    footer={<p></p>} >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedCityForm = Form.create()(CityForm);

export default WrappedCityForm;


// WEBPACK FOOTER //
// ./src/components/CityForm.js